import { render, staticRenderFns } from "./x-btn.vue?vue&type=template&id=e1238568&scoped=true&"
import script from "./x-btn.vue?vue&type=script&lang=ts&"
export * from "./x-btn.vue?vue&type=script&lang=ts&"
import style0 from "./x-btn.vue?vue&type=style&index=0&id=e1238568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1238568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
